/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { TravelItem } from '../../models/travel-item';

export interface TravelControllerMarkAsFinalizing$Params {
  id: number;
}

export function travelControllerMarkAsFinalizing(http: HttpClient, rootUrl: string, params: TravelControllerMarkAsFinalizing$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: TravelItem;
}>> {
  const rb = new RequestBuilder(rootUrl, travelControllerMarkAsFinalizing.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: TravelItem;
      }>;
    })
  );
}

travelControllerMarkAsFinalizing.PATH = '/travel/{id}/finalize';
